import Countries from "../data/countries+states-min.json";

function listCountries() {
  return Countries.map((country) => country.name);
}

function listStates(countryName) {
  if (countryName) {
    return Countries.find((country) => country.name === countryName).states.map(
      (state) => state.name
    );
  } else {
    return [];
  }
}

export { listCountries, listStates };
